import { render, staticRenderFns } from "./uploadReturnUrl.vue?vue&type=template&id=4f57301a&scoped=true&"
import script from "./uploadReturnUrl.vue?vue&type=script&lang=js&"
export * from "./uploadReturnUrl.vue?vue&type=script&lang=js&"
import style0 from "./uploadReturnUrl.vue?vue&type=style&index=0&id=4f57301a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57301a",
  null
  
)

export default component.exports